import React from "react";

import type { TwoUpNavigationCardBlock as Value } from "@reactivated";

import { delegateClickToLink } from "../../utils/delegateClickToLink";
import { Clickable } from "../Clickables";
import { MediaChooserBlock } from "../MediaChooserBlock";

import styles from "./TwoUpNavigationCard.module.scss";

export const TwoUpNavigationCard = ({ value }: { value: Value }) => {
    if (!value.media || !value.link?.url) return <></>;

    return (
        <div className={styles.root} onClick={delegateClickToLink}>
            <MediaChooserBlock
                value={value.media}
                wrapperAttrs={{ className: styles.media }}
                imageProps={{ sizes: styles.sizes }}
            />
            <div className={styles.gradient} />
            <div className={styles.text}>
                {value.eyebrow && (
                    <p className={styles.eyebrow}>{value.eyebrow}</p>
                )}
                <p className={styles.title}>
                    <Clickable
                        simpleLink={value.link}
                        aria-label={value.title ?? undefined}
                    >
                        {value.title}
                    </Clickable>
                </p>
            </div>
        </div>
    );
};
